import { render, staticRenderFns } from "./OrderReports.vue?vue&type=template&id=49cf649a&scoped=true"
import script from "./OrderReports.vue?vue&type=script&lang=js"
export * from "./OrderReports.vue?vue&type=script&lang=js"
import style0 from "./OrderReports.vue?vue&type=style&index=0&id=49cf649a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cf649a",
  null
  
)

export default component.exports